import React from "react";
import { useSelector } from "react-redux";
import { Grid2, Typography } from "@mui/material";
import NotificationList from "Components/Notification/NotificationList";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  maxWidth: "1000px",
  margin: "auto",
});

const Notifications = () => {

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Notifications || {},
  }));

  return (
    <Grid2 sx={styles}>
      <Typography fontWeight={500} variant="title">
        {Translation?.Notifications}
      </Typography>
      <NotificationList />
    </Grid2>
  );
};

export default Notifications;
